import { useState, useEffect, useCallback } from "react";
import { AccountBadge } from "./AccountSwitch";
import * as api from "./api";
import { G } from "./shared";
import TodoPendingPopup from "./tm/components/TodoPendingPopup";
import * as todosApi from "./tm/api-todos";
import { useLegalAlertCount } from "./tm/legal/useLegalAlerts";

export var FALLBACK_ICONS = {
  collect:"M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4",
  report:"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
  consult:"M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m8 0H8m8 0a2 2 0 012 2v6M8 6a2 2 0 00-2 2v6",
  venture:"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
  funding:"M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
  fp:"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z",
  PDF_editor:"M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
  default:"M4 6h16M4 12h16M4 18h16",
};

export default function HomeScreen({ me, onNavigate, onLogout, cachedModules, onModulesLoaded }) {
  var [modules, setModules] = useState(cachedModules || []);
  var [loading, setLoading] = useState(!cachedModules || cachedModules.length === 0);
  var [dragIdx, setDragIdx] = useState(null);
  var [dragOver, setDragOver] = useState(null);

  var brandName = (me && (me.brandingName || (me.branding && me.branding.name))) || "로움파트너스";
  var userName = (me && me.name) || "";
  var isSuper = me && me.isSuper;
  var myId = (me && me.id) || "";
  const legalCount = useLegalAlertCount(!!myId); // 업무관리 타일 빨간 숫자 — 법령·판례·뉴스 새 소식 (한 번만 조회)

  // 할 일 팝업 (같은 날 첫 진입 시 1회, 미완료 있을 때만)
  var [todoPopupOpen, setTodoPopupOpen] = useState(false);
  var [todoToast, setTodoToast] = useState(null);
  useEffect(function() {
    if (!myId) return;
    try {
      var today = new Date().toISOString().slice(0, 10);
      var dismissed = null;
      if (dismissed === today) return;
    } catch (e) { /* ignore */ }
    todosApi.getPendingForMe().then(function(r) {
      if (r && r.success && r.data && r.data.length > 0) setTodoPopupOpen(true);
    }).catch(function(){});
  }, [myId]);

  var fetchModules = useCallback(async function() {
    try {
      var res = await api.getMyModules();
      var data = (res && res.data) ? res.data : (Array.isArray(res) ? res : []);
      setModules(data);
      if (onModulesLoaded) onModulesLoaded(data);
    } catch (e) { console.error("fetchModules:", e); if (e.message && (e.message.includes("인증") || e.message.includes("세션"))) { if (onLogout) onLogout(); return; } }
    finally { setLoading(false); }
  }, [onModulesLoaded]);
  useEffect(function() { fetchModules(); }, [fetchModules]);

  function onDragStart(e, idx) { setDragIdx(idx); e.dataTransfer.effectAllowed = "move"; }
  function onDragEnter(idx) { if (dragIdx !== null && dragIdx !== idx) setDragOver(idx); }
  async function onDrop(e, targetIdx) {
    e.preventDefault();
    if (dragIdx === null || dragIdx === targetIdx) { setDragIdx(null); setDragOver(null); return; }
    var arr = modules.slice(); var item = arr.splice(dragIdx, 1)[0]; arr.splice(targetIdx, 0, item);
    setModules(arr); setDragIdx(null); setDragOver(null);
    try { await api.reorderMyModules(arr.map(function(m,i){return{module_id:m.id,sort_order:i};})); } catch(e2){}
  }
  function onDragEnd() { setDragIdx(null); setDragOver(null); }
  function getIcon(m) { return m.icon_path || FALLBACK_ICONS[m.key] || FALLBACK_ICONS.default; }

  if (loading) return <div style={{minHeight:"100vh",background:"#F3F4F8",display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{color:G[400],fontSize:14}}>로딩중...</div></div>;

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F8" }}>
      <div style={{ background:"#fff", borderBottom:"1px solid "+G[200], padding:"0 24px" }}>
        <div style={{ height:48, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ fontSize:17, fontWeight:800, color:G[900], marginLeft:6 }}>{brandName}</div>
          <div style={{ display:"flex", gap:6, alignItems:"center" }}>
            <AccountBadge name={userName} />
            <button onClick={function(){onNavigate("settings");}} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid "+G[200],background:"#fff",cursor:"pointer",fontSize:11,color:G[500] }}>설정</button>
            <button onClick={onLogout} style={{ padding:"4px 10px",borderRadius:6,border:"1px solid "+G[200],background:"#fff",fontSize:11,color:G[500],cursor:"pointer" }}>로그아웃</button>
          </div>
        </div>
      </div>
      <div style={{ padding:"28px 24px 60px" }}>
        <div style={{ display:"flex", flexWrap:"wrap", gap:20 }}>
          {modules.map(function(m, idx) {
            var ok = !!m.screen_route;
            var dragging = dragIdx === idx;
            var over = dragOver === idx;
            return <div key={m.id} draggable={true}
              onDragStart={function(e){onDragStart(e,idx);}}
              onDragOver={function(e){e.preventDefault();onDragEnter(idx);}}
              onDrop={function(e){onDrop(e,idx);}}
              onDragEnd={onDragEnd}
              onClick={ok?function(){onNavigate(m.screen_route);}:undefined}
              style={{ width:80, textAlign:"center", marginLeft:4, cursor:ok?"pointer":"default", opacity:dragging?0.3:1, transform:over?"scale(1.08)":"none", transition:"transform .1s" }}>
              <div style={{ width:62,height:62,borderRadius:16,margin:"0 auto 6px",background:ok?(m.bg_color||"#EFF6FF"):G[100],display:"flex",alignItems:"center",justifyContent:"center",position:"relative" }}>
                <svg width="29" height="29" viewBox="0 0 24 24" fill="none" stroke={ok?(m.color||"#1E40AF"):G[400]} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d={getIcon(m)}/></svg>
                {m.screen_route==="taskManagement"&&legalCount>0&&<span aria-label={"법령·판례 새 소식 "+legalCount+"건"} title={"법령·판례 새 소식 "+legalCount+"건"} style={{ position:"absolute",top:-6,right:-6,minWidth:20,height:20,padding:"0 6px",borderRadius:10,background:"#DC2626",color:"#fff",fontSize:11,fontWeight:700,lineHeight:"20px",textAlign:"center",boxShadow:"0 0 0 2px #F3F4F8",fontVariantNumeric:"tabular-nums",boxSizing:"border-box" }}>{legalCount>99?"99+":legalCount}</span>}
              </div>
              <div style={{ fontSize:11,fontWeight:500,color:ok?G[800]:G[400],lineHeight:1.3,whiteSpace:"pre-line" }}>{(m.label||"").replace("\\n","\n")}</div>
            </div>;
          })}
        </div>
        {modules.length===0 && <div style={{textAlign:"center",padding:40,color:G[400],fontSize:14}}>접근 가능한 서비스가 없습니다.</div>}
      </div>

      {/* 할 일 팝업 (로그인 후 첫 화면) */}
      {todoPopupOpen && <TodoPendingPopup
        myId={myId}
        onClose={function(){ setTodoPopupOpen(false); }}
        onGoToTodos={function(){
          setTodoPopupOpen(false);
          try { localStorage.setItem("tm_initial_section", "todos"); } catch(e){}
          onNavigate("taskManagement");
        }}
        onToast={function(msg, kind){ setTodoToast({ msg: msg, kind: kind }); }}
      />}

      {todoToast && <div onClick={function(){setTodoToast(null);}} style={{position:"fixed",bottom:20,left:"50%",transform:"translateX(-50%)",background:todoToast.kind==="error"?"#DC2626":"#16A34A",color:"#fff",padding:"10px 18px",borderRadius:8,fontSize:13,fontWeight:600,boxShadow:"0 4px 12px rgba(0,0,0,0.2)",cursor:"pointer",zIndex:2000}}>{todoToast.msg}</div>}
    </div>
  );
}
